import type {
  ReleaseNoteCategory,
  ReleaseNote as ReleaseNoteType,
} from '@/lib/contentful';
import { renderRichText } from '@/lib/contentful';
import { toReadableDate } from '@/lib/dates';

interface ReleaseNoteProps {
  readonly note: ReleaseNoteType;
}

const categoryConfig: Record<ReleaseNoteCategory, { className: string }> = {
  Objektsdatabas: {
    className: 'bg-blue-100 text-blue-800',
  },
  Avtal: {
    className: 'bg-purple-100 text-purple-800',
  },
  Vakanser: {
    className: 'bg-pink-100 text-pink-800',
  },
  'Mina sidor': {
    className: 'bg-cyan-100 text-cyan-800',
  },
  Rapporter: {
    className: 'bg-indigo-100 text-indigo-800',
  },
  'Teknisk förvaltning': {
    className: 'bg-green-100 text-green-800',
  },
  BRF: {
    className: 'bg-yellow-100 text-yellow-800',
  },
  Inkasso: {
    className: 'bg-orange-100 text-orange-800',
  },
  Bokföring: {
    className: 'bg-teal-100 text-teal-800',
  },
  Avisering: {
    className: 'bg-emerald-100 text-emerald-800',
  },
  Fakturering: {
    className: 'bg-red-100 text-red-800',
  },
  IMD: {
    className: 'bg-slate-100 text-slate-800',
  },
};

export function ReleaseNote({ note }: ReleaseNoteProps) {
  return (
    <div className='flex items-start gap-2 pr-2'>
      <img
        src={note.authorImage?.url}
        alt={note.authorImage?.title || note?.author}
        className='size-8 rounded-full object-cover'
      />
      <div className='flex flex-col gap-1'>
        <div className='flex flex-col'>
          <div className='font-medium'>{note.title}</div>
          <p className='w-full text-xs'>
            {note.author} • {toReadableDate(String(note.date.toISOString()))}
          </p>
        </div>
        {note.categories.length > 0 && (
          <div className='flex flex-wrap gap-1.5'>
            {note.categories.map((category) => {
              const config = categoryConfig[category];
              return (
                <span
                  key={category}
                  className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${config.className}`}
                >
                  {category}
                </span>
              );
            })}
          </div>
        )}
        <div className='flex flex-col gap-2'>
          {renderRichText(note.content)}
        </div>
      </div>
    </div>
  );
}
